import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Send, Check } from "lucide-react";

export function ContactForm({ variant = "dark" }) {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus({ type: "", msg: "" });
    try {
      await api.post("/contact", form);
      setStatus({ type: "ok", msg: "Message envoyé. Nous te répondons rapidement." });
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setStatus({ type: "err", msg: formatApiError(err.response?.data?.detail) || "Erreur" });
    } finally {
      setSubmitting(false);
    }
  };

  const u = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const isDark = variant === "dark";
  const inputCls = isDark
    ? "bg-transparent border-b-2 border-[#FAF8F3]/40 focus:border-[#C4944A] w-full py-2 outline-none text-[#FAF8F3]"
    : "bg-transparent border-b-2 border-[#1A1A18]/40 focus:border-[#4A7A3D] w-full py-2 outline-none text-[#1A1A18]";
  const textareaCls = isDark
    ? "bg-[#FAF8F3]/5 border-2 border-[#FAF8F3]/30 focus:border-[#C4944A] w-full p-3 outline-none text-[#FAF8F3] placeholder:text-[#FAF8F3]/30"
    : "bg-[#FAF8F3] border-2 border-[#1A1A18]/30 focus:border-[#4A7A3D] w-full p-3 outline-none text-[#1A1A18]";
  const labelCls = isDark ? "text-[#C4944A]" : "text-[#4A7A3D]";

  return (
    <form onSubmit={submit} className={`space-y-6 border-2 p-6 md:p-8 ${isDark ? "border-[#FAF8F3]/30 bg-[#1A1A18]" : "border-[#1A1A18] bg-[#F5EFEB]"}`} data-testid="contact-form">
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className={`font-mono-label block mb-2 ${labelCls}`}>Nom</label>
          <input type="text" required value={form.name} onChange={(e) => u("name", e.target.value)} className={inputCls} data-testid="contact-name" />
        </div>
        <div>
          <label className={`font-mono-label block mb-2 ${labelCls}`}>Email</label>
          <input type="email" required value={form.email} onChange={(e) => u("email", e.target.value)} className={inputCls} data-testid="contact-email" />
        </div>
      </div>
      <div>
        <label className={`font-mono-label block mb-2 ${labelCls}`}>Sujet</label>
        <input type="text" value={form.subject} onChange={(e) => u("subject", e.target.value)} placeholder="Proposition d'article, demande presse, contribution…" className={inputCls} data-testid="contact-subject" />
      </div>
      <div>
        <label className={`font-mono-label block mb-2 ${labelCls}`}>Message</label>
        <textarea rows={6} required minLength={5} value={form.message} onChange={(e) => u("message", e.target.value)} placeholder="Écris-nous ton message…" className={textareaCls} data-testid="contact-message" />
      </div>
      {status.msg && (
        <div className={`font-mono-label flex items-center gap-2 ${status.type === "err" ? (isDark ? "text-red-300" : "text-red-700") : (isDark ? "text-[#8FAF82]" : "text-[#4A7A3D]")}`} data-testid="contact-status">
          {status.type === "ok" && <Check size={14} />} {status.msg}
        </div>
      )}
      <button type="submit" disabled={submitting} className={`px-8 py-4 font-mono-label flex items-center gap-2 disabled:opacity-60 ${isDark ? "bg-[#C4944A] text-[#1A1A18] hover:bg-[#FAF8F3]" : "bg-[#4A7A3D] text-[#FAF8F3] hover:bg-[#3E6633]"}`} data-testid="contact-submit">
        <Send size={14} /> {submitting ? "Envoi…" : "Envoyer le message"}
      </button>
    </form>
  );
}
